import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Disclaimer.scss';

const Disclaimer = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
        const id = location.hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
            setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        }
        }
    }, [location]);

    return (
    <div className='disclaimer'><p>Desarrollado por <a href="https://uy.linkedin.com/in/lautaro-tamborindeguy-a75837188" target="_blank" rel="noopener noreferrer">Lautaro&nbsp;Tamborindeguy</a> <a href="https://wa.me/59898307550" target="_blank" rel="noopener noreferrer">+598&nbsp;98307550</a></p></div>
  );
};
export default Disclaimer;

